export default __webpack_public_path__ + "static/media/002-animal feed.9a092810.svg";